module.exports = __webpack_public_path__ + "static/Toronto-cda5d39f1eae54dc0c1b212cd41e8e3a.jpg";